import { useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'hooks';
import { setTimezone } from 'store/applicationReducer';

const TIMEZONES = [
    { value: 'Asia/Seoul', label: 'Asia/Seoul' },
    { value: 'Asia/Taipei', label: 'Asia/Taipei' }
];

// React pages that support timezone switching
const REACT_PAGES = [
    '/search/member',
    '/search/account',
    '/search/team',
    '/billing/contract',
    '/billing/promotion',
    '/billing/statement',
    '/billing/statement-test',
    '/history/push',
    '/history/event',
    '/history/platform',
    '/history/account',
    '/history/storage',
    '/manage/forceUpdate',
    '/manage/mail',
    '/manage/sticker',
    '/dashboard'
];

const TimezoneSelector = () => {
    const dispatch = useAppDispatch();
    const timezone = useAppSelector((state) => state.application.timezone);
    const location = useLocation();

    const isReactPage = REACT_PAGES.some((path) => location.pathname.startsWith(path));
    if (!isReactPage) return null;

    return (
        <div className="gd-tz">
            <label className="gd-tz__label" htmlFor="gd-tz-select">
                Timezone
            </label>
            <select
                id="gd-tz-select"
                className="gd-tz__select"
                value={timezone}
                onChange={(e) => dispatch(setTimezone(e.target.value))}
            >
                {TIMEZONES.map((tz) => (
                    <option key={tz.value} value={tz.value}>
                        {tz.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TimezoneSelector;
